var mode = 1; // 开发模式,0是开发环境,连接测试接口; 1是生产环境,连接正式接口
var apiUrl = ''
var adimgUrl = ''
var company = '强企宝典(山东)信息科技有限公司'; // 企业名称
var copyrightYear = new Date().getFullYear();
var ossUrl = '...ossurl...';
var ossUrlCallBack = '...osscallback...';

var file_pdf_wanzheng = 'https://upldfile.qqbd.vip/source_pdf/' // 招股说明书或问询答复的完整文件下载路径，示例：https://upldfile.qqbd.vip/source_pdf/034814ce012e46c3ad76a8d4d9e11fbd.pdf
var file_pdf_fenge = 'https://upldfile.qqbd.vip/part_pdf/' // （暂不启用，接口已返回完整URL）分文文件的下载路径（分割时需要多拼个文件ID），示例：https://upldfile.qqbd.vip/part_pdf/文件ID/e72a51965c1f11ed9d2600163e016522.pdf
var file_tuwen = 'https://sudomanage.qqbd.vip/profile/upload/2022/07/29/e24ac1d6-b40c-4ee8-a199-3bc4febc52db.docx' // （暂不启用）图文附件的下载路径 数据库中完整链接，不需要拼接

if(mode == 0) {
	apiUrl = 'http://localhost:58080/pubapi/'
	// adimgUrl = 'http://localhost:58080/'
	adimgUrl = 'https://service.qqbd.vip/'
}else if(mode == 1) {
	apiUrl = 'https://service.qqbd.vip/pubapi/'
	adimgUrl = 'https://service.qqbd.vip/' // 经测试，这里不需要加profile
}


export default{
	apiUrl,
	adimgUrl,
	company,
	copyrightYear,
	ossUrl,
	ossUrlCallBack,
	file_pdf_wanzheng,
	file_pdf_fenge,
	file_tuwen
}